import React from 'react';
import CreatableSelect from 'react-select/creatable';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

import './styles.css';

class CreatableLazySelect extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      query: '',
      hasMore: true,
      options: [],
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.getOption();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.value !== this.props.value) {
      this.getOption();
    }

    if (prevState.query !== this.state.query) {
      this.getOption(null, true);
    }
  }

  getOptionsByScrollEvent = async () => {
    const { query, options, hasMore } = this.state;

    if (!hasMore) {
      return;
    }

    const response = await this.props.getOption(query, options.length);

    if (this._isMounted) {
      const updatedOptions =
        response.options && response.options.length > 0
          ? [...this.state.options, ...response.options]
          : [...this.state.options];

      this.setState({
        hasMore:
          !response.hasMore && response.has_more
            ? response.has_more
            : response.hasMore || false,
        options: updatedOptions,
      });
    }
  };

  getOption = async () => {
    const { query } = this.state;
    const response = await this.props.getOption(query, 0);

    if (this._isMounted) {
      const updatedOptions =
        response.options && response.options.length > 0
          ? [...response.options]
          : [];

      this.setState({
        hasMore:
          !response.hasMore && response.has_more
            ? response.has_more
            : response.hasMore || false,
        options: updatedOptions,
      });
    }
  };

  handleChange = selectedOption => {
    if (this.props.onChange) {
      this.props.onChange(this.props.name, selectedOption);
    } else {
      this.props.controlFunc(selectedOption, this.props.name);
    }
  };

  handleOnBlur = e => {
    if (this.props.onBlur) {
      this.props.onBlur(this.props.name, true);
    } else if (this.props.touchFunc) {
      this.props.touchFunc(e);
    }
  };

  controlInputChangeFunc = debounce((value, { action }) => {
    if (this._isMounted) {
      if (action === 'input-change') {
        this.setState({ query: value, hasMore: true });
      } else if (action === 'menu-close') {
        this.setState({ query: '', hasMore: true });
      }
    }
  }, 300);

  render() {
    const {
      value,
      name,
      label,
      required,
      placeholder,
      isValid,
      labelStyles,
      isMulti = false,
      isLast = false,
      isDisabled = false,
    } = this.props;

    const isRequired = required
      ? 'creatable-value-select__label-text creatable-value-select__label-text--required'
      : 'creatable-value-select__label-text';

    const customStyles = {
      control: base => ({
        ...base,
        borderColor: isValid ? '#a0a0a0' : '#f40',
      }),
    };

    return (
      <div
        className={
          isLast
            ? 'creatable-value-select__wrapper creatable-value-select__wrapper--last'
            : 'creatable-value-select__wrapper'
        }
      >
        <label
          className="creatable-value-select__label"
          htmlFor={name}
          style={labelStyles}
        >
          <span className={isRequired}>{label}</span>
        </label>
        <CreatableSelect
          isDisabled={isDisabled}
          blurInputOnSelect={true}
          instanceId={Date.now()}
          styles={customStyles}
          value={value}
          isClearable
          isMulti={isMulti}
          isSearchable
          onChange={this.handleChange}
          onInputChange={this.controlInputChangeFunc}
          name={name}
          options={this.state.options}
          className="creatable-value-select"
          classNamePrefix="creatable-value-select"
          placeholder={placeholder}
          onBlur={this.handleOnBlur}
          onMenuScrollToBottom={this.getOptionsByScrollEvent}
        />
      </div>
    );
  }
}

CreatableLazySelect.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  controlFunc: PropTypes.func,
  controlInputChangeFunc: PropTypes.func,
  isValid: PropTypes.bool.isRequired,
  isMulti: PropTypes.bool,
  placeholder: PropTypes.string,
  touchFunc: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  isLast: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

export default CreatableLazySelect;
